import { render, staticRenderFns } from "./SortData.vue?vue&type=template&id=bbf2321e"
import script from "./SortData.vue?vue&type=script&lang=js"
export * from "./SortData.vue?vue&type=script&lang=js"
import style0 from "../../src/assets/styles/sortCss.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports